import { QueryClient } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

const NO_RETRY_STATUS = [400, 401, 403, 404];
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (failureCount > 3) return false;
        if (!isAxiosError(error)) return false;
        const statusCode = error.response?.status ?? 0;
        if (NO_RETRY_STATUS.includes(statusCode)) return false;
        // Do not retry if already retried by Axios
        // See ./src/api/client.ts
        const attempt = (error.config as any)?.attempt ?? 0;
        if (attempt > 0) return false;
        return true;
      }
    }
  }
});
